{
  "nav.myForms": "Meus formul\u00e1rios",
  "nav.myMarketplace": "My marketplace",
  "nav.logout": "Sair",

  "dashboard.subtitle": "Plataforma low-code de formul\u00e1rios. Gerencie formul\u00e1rios e dados.",
  "dashboard.card.myForms.description": "Veja seus formul\u00e1rios ou crie um novo com campos de arrastar e soltar.",

  "forms.list.title": "Meus formul\u00e1rios",
  "forms.list.description": "Crie ou edite defini\u00e7\u00f5es de formul\u00e1rio.",
  "forms.list.new": "Novo formul\u00e1rio",
  "forms.list.empty": "Nenhum formul\u00e1rio ainda. Crie um para come\u00e7ar.",
  "forms.list.error": "Falha ao carregar formul\u00e1rios.",
  "forms.list.deleteConfirm": "Excluir o formul\u00e1rio \"{{name}}\" e todos os seus dados?",
  "forms.list.deleteError": "Falha ao excluir formul\u00e1rio.",

  "marketplace.title": "My marketplace",
  "marketplace.description": "Adicione formul\u00e1rios do marketplace a esta conta de cliente.",
  "marketplace.available": "Formul\u00e1rios dispon\u00edveis",
  "marketplace.assigned": "Formul\u00e1rios atribu\u00eddos",
  "marketplace.emptyAvailable": "Nenhum formul\u00e1rio do marketplace est\u00e1 dispon\u00edvel para adicionar agora.",
  "marketplace.emptyAssigned": "Nenhum formul\u00e1rio do marketplace foi atribu\u00eddo ainda.",
  "marketplace.add": "Adicionar",
  "marketplace.adding": "Adicionando\u2026",
  "marketplace.added": "\"{{name}}\" foi adicionado a esta conta.",
  "marketplace.assignedBadge": "Atribu\u00eddo",
  "marketplace.removing": "\u2026",
  "marketplace.loadError": "Falha ao carregar formul\u00e1rios do marketplace.",
  "marketplace.customerMissing": "N\u00e3o foi poss\u00edvel identificar a conta de cliente atual.",

  "forms.builder.back": "\u2190 Voltar para formul\u00e1rios",
  "forms.builder.title.new": "Novo formul\u00e1rio",
  "forms.builder.title.edit": "Editar formul\u00e1rio",
  "forms.builder.name.label": "Nome do formul\u00e1rio",
  "forms.builder.name.placeholder": "Meu formul\u00e1rio",
  "forms.builder.loadError": "Falha ao carregar formul\u00e1rio.",
  "forms.builder.fields.heading": "Campos",
  "forms.builder.fields.hint": "Arraste um tipo de campo para o formul\u00e1rio.",
  "forms.builder.canvas.heading": "Layout do formul\u00e1rio",
  "forms.builder.canvas.placeholder": "Solte os campos aqui",
  "forms.builder.properties.heading": "Propriedades",
  "forms.builder.listOptions.placeholder": "Op\u00e7\u00e3o 1\nOp\u00e7\u00e3o 2\nOp\u00e7\u00e3o 3",
  "forms.builder.remove": "Remover campo",
  "forms.builder.canvas.addCard": "Adicionar card",
  "forms.builder.canvas.untitledCard": "Card sem t\u00edtulo",

  "forms.run.back": "\u2190 Voltar para formul\u00e1rios",
  "forms.run.fallbackTitle": "Ver formul\u00e1rio",
  "forms.run.notFound": "Formul\u00e1rio n\u00e3o encontrado",
  "forms.run.loadError": "Falha ao carregar",
  "forms.run.validation.mandatory": "\"{{label}}\" \u00e9 obrigat\u00f3rio. Preencha o campo.",
  "forms.run.validation.maskInvalid": "\"{{label}}\" \u00e9 inv\u00e1lido.",
  "forms.run.deleteConfirm": "Excluir este item?",
  "forms.run.deleteFailed": "Falha ao excluir",
  "forms.run.empty": "Nenhum item ainda. Adicione um acima.",
  "forms.run.saveFailed": "Falha ao salvar",
  "forms.run.actions": "A\u00e7\u00f5es",
  "forms.run.addRecord": "Adicionar registro",

  "auth.notAuthenticated": "N\u00e3o autenticado",

  "login.logAsAdmin": "Entrar como administrador",

  "common.save": "Salvar",
  "common.saving": "Salvando\u2026",
  "common.update": "Atualizar",
  "common.create": "Criar",
  "common.cancel": "Cancelar",
  "common.loading": "Carregando\u2026",
  "common.edit": "Editar",
  "common.delete": "Excluir",
  "common.close": "Fechar",
  "common.search": "buscar"
}
